import { State } from "redux/state/types";
import { CreateApiResponse, FetchApiResponse, FilterMetadata } from "redux/types";

export enum PayableChargeReduxTypes {
  FETCH_PAYABLE_CHARGES = "@@auth/FETCH_PAYABLE_CHARGES",
  FETCH_PAYABLE_CHARGES_SUCCESS = "@@auth/FETCH_PAYABLE_CHARGES_SUCCESS",
  FETCH_PAYABLE_CHARGES_ERROR = "@@auth/FETCH_PAYABLE_CHARGES_ERROR",

  FETCH_PAYABLE_CHARGE = "@@auth/FETCH_PAYABLE_CHARGE",
  FETCH_PAYABLE_CHARGE_SUCCESS = "@@auth/FETCH_PAYABLE_CHARGE_SUCCESS",
  FETCH_PAYABLE_CHARGE_ERROR = "@@auth/FETCH_PAYABLE_CHARGE_ERROR",

  CREATE_PAYABLE_CHARGE = "@@auth/CREATE_PAYABLE_CHARGE",
  CREATE_PAYABLE_CHARGE_SUCCESS = "@@auth/CREATE_PAYABLE_CHARGE_SUCCESS",
  CREATE_PAYABLE_CHARGE_ERROR = "@@auth/CREATE_PAYABLE_CHARGE_ERROR",

  UPDATE_PAYABLE_CHARGE = "@@auth/UPDATE_PAYABLE_CHARGE",
  UPDATE_PAYABLE_CHARGE_SUCCESS = "@@auth/UPDATE_PAYABLE_CHARGE_SUCCESS",
  UPDATE_PAYABLE_CHARGE_ERROR = "@@auth/UPDATE_PAYABLE_CHARGE_ERROR",


  DELETE_PAYABLE_CHARGE = "@@auth/DELETE_PAYABLE_CHARGE",
  DELETE_PAYABLE_CHARGE_SUCCESS = "@@auth/DELETE_PAYABLE_CHARGE_SUCCESS",
  DELETE_PAYABLE_CHARGE_ERROR = "@@auth/DELETE_PAYABLE_CHARGE_ERROR",

  FETCH_PAYABLE_CHARGE_VERSION = "@@auth/FETCH_PAYABLE_CHARGE_VERSION",
  FETCH_PAYABLE_CHARGE_VERSION_SUCCESS = "@@auth/FETCH_PAYABLE_CHARGE_VERSION_SUCCESS",
  FETCH_PAYABLE_CHARGE_VERSION_ERROR = "@@auth/FETCH_PAYABLE_CHARGE_VERSION_ERROR",

  FETCH_PAYABLE_CHARGE_VERSION_DETAILS = "@@auth/FETCH_PAYABLE_CHARGE_VERSION_DETAILS",
  FETCH_PAYABLE_CHARGE_VERSION_DETAILS_SUCCESS = "@@auth/FETCH_PAYABLE_CHARGE_VERSION_DETAILS_SUCCESS",
  FETCH_PAYABLE_CHARGE_VERSION_DETAILS_ERROR = "@@auth/FETCH_PAYABLE_CHARGE_VERSION_DETAILS_ERROR",

  FETCH_PAYABLE_CHARGE_LATEST_VERSION = "@@auth/FETCH_PAYABLE_CHARGE_LATEST_VERSION",
  FETCH_PAYABLE_CHARGE_LATEST_VERSION_SUCCESS = "@@auth/FETCH_PAYABLE_CHARGE_LATEST_VERSION_SUCCESS",
  FETCH_PAYABLE_CHARGE_LATEST_VERSION_ERROR = "@@auth/FETCH_PAYABLE_CHARGE_LATEST_VERSION_ERROR",

  APPROVE_PAYABLE_CHARGE = "@@auth/APPROVE_PAYABLE_CHARGE",
  APPROVE_PAYABLE_CHARGE_SUCCESS = "@@auth/APPROVE_PAYABLE_CHARGE_SUCCESS",
  APPROVE_PAYABLE_CHARGE_ERROR = "@@auth/APPROVE_PAYABLE_CHARGE_ERROR",

  REJECT_PAYABLE_CHARGE = "@@auth/REJECT_PAYABLE_CHARGE",
  REJECT_PAYABLE_CHARGE_SUCCESS = "@@auth/REJECT_PAYABLE_CHARGE_SUCCESS",
  REJECT_PAYABLE_CHARGE_ERROR = "@@auth/REJECT_PAYABLE_CHARGE_ERROR",

  BLOCK_PAYABLE_CHARGE = "@@auth/BLOCK_PAYABLE_CHARGE",
  BLOCK_PAYABLE_CHARGE_SUCCESS = "@@auth/BLOCK_PAYABLE_CHARGE_SUCCESS",
  BLOCK_PAYABLE_CHARGE_ERROR = "@@auth/BLOCK_PAYABLE_CHARGE_ERROR",

  FREEZE_PAYABLE_CHARGE = "@@auth/FREEZE_PAYABLE_CHARGE",
  FREEZE_PAYABLE_CHARGE_SUCCESS = "@@auth/FREEZE_PAYABLE_CHARGE_SUCCESS",
  FREEZE_PAYABLE_CHARGE_ERROR = "@@auth/FREEZE_PAYABLE_CHARGE_ERROR",

  UNFREEZE_PAYABLE_CHARGE = "@@auth/UNFREEZE_PAYABLE_CHARGE",
  UNFREEZE_PAYABLE_CHARGE_SUCCESS = "@@auth/UNFREEZE_PAYABLE_CHARGE_SUCCESS",
  UNFREEZE_PAYABLE_CHARGE_ERROR = "@@auth/UNFREEZE_PAYABLE_CHARGE_ERROR",

  RESET = "@@auth/RESET"
}

export type PayableChargeActionDispatch = {
  type:
    | PayableChargeReduxTypes.FETCH_PAYABLE_CHARGES
    | PayableChargeReduxTypes.FETCH_PAYABLE_CHARGE
    | PayableChargeReduxTypes.CREATE_PAYABLE_CHARGE
    | PayableChargeReduxTypes.UPDATE_PAYABLE_CHARGE
    | PayableChargeReduxTypes.DELETE_PAYABLE_CHARGE

    | PayableChargeReduxTypes.FETCH_PAYABLE_CHARGE_VERSION
    | PayableChargeReduxTypes.FETCH_PAYABLE_CHARGE_VERSION_DETAILS
    | PayableChargeReduxTypes.FETCH_PAYABLE_CHARGE_LATEST_VERSION
    | PayableChargeReduxTypes.APPROVE_PAYABLE_CHARGE
    | PayableChargeReduxTypes.REJECT_PAYABLE_CHARGE
    | PayableChargeReduxTypes.BLOCK_PAYABLE_CHARGE
    | PayableChargeReduxTypes.FREEZE_PAYABLE_CHARGE
    | PayableChargeReduxTypes.UNFREEZE_PAYABLE_CHARGE
    | PayableChargeReduxTypes.RESET;
  payload: any;
};

export type PayableChargeReducerDispatch = {
  type:
    | PayableChargeReduxTypes.FETCH_PAYABLE_CHARGES
    | PayableChargeReduxTypes.FETCH_PAYABLE_CHARGES_SUCCESS
    | PayableChargeReduxTypes.FETCH_PAYABLE_CHARGES_ERROR
    | PayableChargeReduxTypes.FETCH_PAYABLE_CHARGE_SUCCESS
    | PayableChargeReduxTypes.FETCH_PAYABLE_CHARGE_ERROR
    | PayableChargeReduxTypes.CREATE_PAYABLE_CHARGE_SUCCESS
    | PayableChargeReduxTypes.CREATE_PAYABLE_CHARGE_ERROR
    | PayableChargeReduxTypes.UPDATE_PAYABLE_CHARGE_SUCCESS
    | PayableChargeReduxTypes.UPDATE_PAYABLE_CHARGE_ERROR
    | PayableChargeReduxTypes.DELETE_PAYABLE_CHARGE
    | PayableChargeReduxTypes.DELETE_PAYABLE_CHARGE_SUCCESS
    | PayableChargeReduxTypes.DELETE_PAYABLE_CHARGE_ERROR

    | PayableChargeReduxTypes.FETCH_PAYABLE_CHARGE_VERSION_SUCCESS
    | PayableChargeReduxTypes.FETCH_PAYABLE_CHARGE_VERSION_ERROR
    | PayableChargeReduxTypes.FETCH_PAYABLE_CHARGE_VERSION_DETAILS
    | PayableChargeReduxTypes.FETCH_PAYABLE_CHARGE_VERSION_DETAILS_SUCCESS
    | PayableChargeReduxTypes.FETCH_PAYABLE_CHARGE_VERSION_DETAILS_ERROR
    | PayableChargeReduxTypes.FETCH_PAYABLE_CHARGE_LATEST_VERSION
    | PayableChargeReduxTypes.FETCH_PAYABLE_CHARGE_LATEST_VERSION_SUCCESS
    | PayableChargeReduxTypes.FETCH_PAYABLE_CHARGE_LATEST_VERSION_ERROR
    | PayableChargeReduxTypes.APPROVE_PAYABLE_CHARGE
    | PayableChargeReduxTypes.APPROVE_PAYABLE_CHARGE_SUCCESS
    | PayableChargeReduxTypes.APPROVE_PAYABLE_CHARGE_ERROR
    | PayableChargeReduxTypes.REJECT_PAYABLE_CHARGE
    | PayableChargeReduxTypes.REJECT_PAYABLE_CHARGE_SUCCESS
    | PayableChargeReduxTypes.REJECT_PAYABLE_CHARGE_ERROR
    | PayableChargeReduxTypes.BLOCK_PAYABLE_CHARGE_SUCCESS
    | PayableChargeReduxTypes.BLOCK_PAYABLE_CHARGE_ERROR
    | PayableChargeReduxTypes.FREEZE_PAYABLE_CHARGE_SUCCESS
    | PayableChargeReduxTypes.FREEZE_PAYABLE_CHARGE_ERROR
    | PayableChargeReduxTypes.UNFREEZE_PAYABLE_CHARGE_SUCCESS
    | PayableChargeReduxTypes.UNFREEZE_PAYABLE_CHARGE_ERROR
    | PayableChargeReduxTypes.RESET;
  payload: {
    data?: FetchApiResponse<PayableCharge>;
    error?: string;
  };
};

export type PayableChargeReduxState = {
  loading?: boolean;
  data?: FetchApiResponse<PayableCharge>;
  error?: string | null;
};

export type PayableCharge = {
  id: string;
  programId: string;
  chargeType: string;
  gstPercentage: string;
  amountWithoutGst: string;
  gstAmount: string;
  amount: string;
  active: boolean;
  createdOn: Date;
  updatedOn: Date;
  externalId: string;
};

export type CitiesFetchRequest = {
  payload: FilterMetadata;
  type: string;
};

export type CreatePayableChargeReduxState = {
  loading?: boolean;
  data?: CreateApiResponse<PayableCharge>;
  error?: string | null;
};

export type CreatePayableCharge = {
  buyerSellerId: string;
  chargeType: string;
  gstPercentage: string;
  amountWithoutGst: string;
  gstAmount: string;
  amount: string;
  draft: boolean;
  makerRemarks: string;
};

export type UpdatePayableCharge = {
  name: string;
  stateId: string;
  id: string;
  makerRemarks: string;
  draft: string;
};

export type CreatePayableChargeRequest = {
  payload: CreatePayableCharge;
  type: string;
};

export type UpdatePayableChargeRequest = {
  payload: UpdatePayableCharge;
  type: string;
};

export type FetchPayableChargeByIdRequest = {
  payload: string;
  type: string;
};
